export type OnboardingPersonalState = {
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  mobile: string;
  alternativeName: string;
  gender: string;
  nationality: string;
  hirerABN: string;
  tollTagNumber: string;
  tollTagAccountNumber: string;
  tollTagIssuer: string;
  nationalInsuranceNumber: string;
};

export type OnboardingPersonalAction =
  | { type: "SET_FIRST_NAME"; payload: string }
  | { type: "SET_MIDDLE_NAME"; payload: string }
  | { type: "SET_LAST_NAME"; payload: string }
  | { type: "SET_EMAIL"; payload: string }
  | { type: "SET_MOBILE"; payload: string }
  | { type: "SET_ALTERNATIVE_NAME"; payload: string }
  | { type: "SET_GENDER"; payload: string }
  | { type: "SET_NATIONALITY"; payload: string }
  | { type: "SET_HIRER_ABN"; payload: string }
  | { type: "SET_TOLL_TAG_NUMBER"; payload: string }
  | { type: "SET_TOLL_TAG_ACCOUNT_NUMBER"; payload: string }
  | { type: "SET_TOLL_TAG_ISSUER"; payload: string }
  | { type: "SET_NATIONAL_INSURANCE_NUMBER"; payload: string }
  | { type: "SET_ALL"; payload: Partial<OnboardingPersonalState> };

export const onboardingPersonalInitialState: OnboardingPersonalState = {
  firstName: "",
  middleName: "",
  lastName: "",
  email: "",
  mobile: "",
  alternativeName: "",
  gender: "",
  nationality: "",
  hirerABN: "",
  tollTagNumber: "",
  tollTagAccountNumber: "",
  tollTagIssuer: "",
  nationalInsuranceNumber: "",
};

export function onboardingPersonalReducer(state: OnboardingPersonalState, action: OnboardingPersonalAction): OnboardingPersonalState {
  switch (action.type) {
    case "SET_FIRST_NAME":
      return { ...state, firstName: action.payload };
    case "SET_MIDDLE_NAME":
      return { ...state, middleName: action.payload };
    case "SET_LAST_NAME":
      return { ...state, lastName: action.payload };
    case "SET_EMAIL":
      return { ...state, email: action.payload };
    case "SET_MOBILE":
      return { ...state, mobile: action.payload };
    case "SET_ALTERNATIVE_NAME":
      return { ...state, alternativeName: action.payload };
    case "SET_GENDER":
      return { ...state, gender: action.payload };
    case "SET_NATIONALITY":
      return { ...state, nationality: action.payload };
    case "SET_HIRER_ABN":
      return { ...state, hirerABN: action.payload };
    case "SET_TOLL_TAG_NUMBER":
      return { ...state, tollTagNumber: action.payload };
    case "SET_TOLL_TAG_ACCOUNT_NUMBER":
      return { ...state, tollTagAccountNumber: action.payload };
    case "SET_TOLL_TAG_ISSUER":
      return { ...state, tollTagIssuer: action.payload };
    case "SET_NATIONAL_INSURANCE_NUMBER":
      return { ...state, nationalInsuranceNumber: action.payload };
    case "SET_ALL":
      return { ...state, ...action.payload };
    default:
      console.log(`Error - incorrect action sent ${JSON.stringify(action)} ${JSON.stringify(state)}`);
      return state;
  }
}
